import { FormlyFieldConfig } from "@ngx-formly/core";
import { LinkDownload } from "app/formly/link-download.type";
import { AllegatiBolliAltroStep } from "../../shared/allegati-bolli-altro.step";

export const AllegatiDehorStep: FormlyFieldConfig[] =[
    {
      "props": { "label": 'ALLEGATI ' },
      "fieldGroup": [
        {
          "key": 'allegati_relazione_tecnica',
          "type": 'mat-upload',
          "props": {
            "label": "RELAZIONE TECNICA",
            "multiple": true,
            "required":true
          },
        },
        {
          "key": 'allegati_grafici',
          "type": 'mat-upload',
          "props": {
            "label": "GRAFICI",
            "multiple": true,
            "required":true
          },
          // "expressions":{
          //   'props.required': (field)=> this.allegati && !this.allegati[String(field.key)]?.length
          // },
        },
        {
          "key": 'allegati_foto',
          "type": 'mat-upload',
          "props": {
            "label": "FOTO DEL LUOGO",
            "multiple": true,
            "required":true
          },
        },
        {
          "key": 'allegati_fotoinserimento',
          "type": 'mat-upload',
          "props": {
            "label": "FOTO INSERIMENTO",
            "multiple": true,
          },
        },
      ]
    },
  ]

